import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserSessionService } from '../../shared/services/user-session.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private userSessionService: UserSessionService, private router: Router) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (!this.userSessionService.validateAuthToken()) {
            this.userSessionService.clearUserSession();
            this.router.navigate(['/']);
            return false;
        }
        return true;
    }
}
